<template>
  <b-overlay :show="showOverlay">
    <Breadcrumb/>
    <b-modal
      id="modal-borrow-operator"
      shadow
      bg-variant="white"
      backdrop
      hide-footer
      centered
    >
      <ModalBorrowOperation
        :showToast="showToast"
        :operator="operator"
        :workcenters="workcentersListFiltered"
        :createAlert="getAlerts"
      />
    </b-modal>
    <ModalTable
      :rows="rowsCDO"
      :fields="fieldsCDO"
      :stickyHeader="false"
      :striped="true"
      :TitleVar="cdoID"
    >
      <template v-slot:cell(date)="data" >
        <span class="width-cdo-date-column">
          {{data.item.date | moment("DD/MM/YYYY")}}
        </span>
      </template>

      <template v-slot:cell(workcenter)="data">
        <div class="add-ellipsis width-cdo-workcenter-column">
          <span :id="`tooltip-cdo-workcenter-${data.index}`">
            {{data.item.workcenter}}
          </span>
        </div>
        <b-tooltip
            :target="`tooltip-cdo-workcenter-${data.index}`"
            triggers="hover blur"
            positioning="top"
            placement="top"
        >
            <div class="info-tooltip">
               {{data.item.workcenter}}
            </div>
        </b-tooltip>
      </template>

      <template v-slot:cell(operator)="data">
        <div class="add-ellipsis width-cdo-operator-column">
          <span :id="`tooltip-cdo-operator-${data.index}`">
            {{data.item.operator}}
          </span>
        </div>
        <b-tooltip
            :target="`tooltip-cdo-operator-${data.index}`"
            triggers="hover blur"
            positioning="top"
            placement="top"
        >
            <div class="info-tooltip">
               {{data.item.operator}}
            </div>
        </b-tooltip>
      </template>
    </ModalTable>

    <b-row class="alertas-apontamentos">
      <b-col md=12  v-if="erroApontamento" class="alerta-apontamentos-row">
        <div  class="alerta-apontamentos --apontamento-red col-12">
          <b-col class="col-10 p-0 alerta-apontamentos-item">
            <span class="col-10 p-0">Existem apontamentos divergentes do ponto.</span>
          </b-col>
          <b-col class="col-2 d-flex justify-content-end p-0 alerta-apontamentos-item">
            <CloseIcon  class="icon-close" @click="erroApontamento = !erroApontamento"/>
          </b-col>
        </div>
      </b-col>
      <b-col
        md=12
        v-if="alerts"
        class="alerta-apontamentos-row"
        v-for="(alert, index) in alerts"
        :key="`alert-${index}`"
        :id="`alert-${index}`"
      >
        <div class="alerta-apontamentos --apontamento-gray col-12">
          <b-col class="col-10 p-0 alerta-apontamentos-item">
            <span>
              <span v-for="(name, index) in alert.operator" :key="index">
                {{name}}<span v-if="index < (alert.operator.length - 1) && alert.operator.length > 1">,</span>
              </span>
              <span>
                {{alert.operator.length > 1 ? 'foram movidos' : 'foi movido'}} para o {{alert.new_workcenter}}
              </span>
            </span>
          </b-col>
          <b-col class="col-2 d-flex justify-content-end p-0 alerta-apontamentos-item">
            <CloseIcon  class="icon-close" @click="closeAlert(alert.ids, index)"/>
          </b-col>
        </div>
      </b-col>
    </b-row>
    <b-row class="row-buttons-pages">
      <b-col md="12" class="col-btn-pages">
          <div
            :class="['button-page', flagApontamentos && 'active']"
             @click="atualizaPaginaApontamento()"
          >
              <span class="title-button">Apontamentos</span>
              <span class="sub-title-button">Realizar novo apontamento</span>
          </div>
          <div
            :class="['button-page', flagApropiacaoHoras && 'active']"
             @click="habilitaInfos('horas')"
          >
              <span class="title-button">Apropriação Horas</span>
              <span class="sub-title-button">Base apropriação horas</span>
          </div>
          <div
            :class="['button-page', flagAvanco && 'active']"
             @click="habilitaInfos('avanco')"
          >
              <span class="title-button">Avanço</span>
              <span class="sub-title-button">Realizar avanço de escopo</span>
          </div>
          <div
            :class="['button-page', flagDivergencias && 'active']"
             @click="habilitaInfos('divergencias')"
          >
              <span class="title-button">Divergências</span>
              <span class="sub-title-button">Verificar divergências</span>
          </div>
      </b-col>
    </b-row>
    <b-row v-if="infoApontamentos">
        <b-col md="12">
            <b-card class="info-apontamento">

                <carousel-calendar
                :mesAnoAtual="mesAtualApontamento"
                :datasInconsistentes="datasInconsistentes"
                :datasApontamentos="datasApontamentos"
                :mesesApontamentos="mesesApontamentos"
                :dataSelecionada="dataAtualApontamento"
                :datasDivergencias="datasDivergencias"
                @atualizaUrl="(value) => getProductionHoursOperators(value)"
                />
                <table-default
                  :rows="rowsApontamentofiltrado"
                  :fields="fieldsApontamento"
                  :stickyHeader="false"
                  :striped="true"
                  :sizeSearchLg="6"
                  class="tabela-apontamentos"
                >
                  <template v-slot:cell(checkbox)="data">
                    <b-form-checkbox
                      :id="'checkbox-' + data.index"
                      class="checkbox-row"
                      v-model="selected"
                      :value="data.item.id"
                      :disabled="(parseFloat(data.item.difference_hn) == 0 && parseFloat(data.item.difference_he) == 0) || parseFloat(data.item.difference_hn) < margemApontamento || parseFloat(data.item.difference_he) < margemApontamento "
                    >
                    </b-form-checkbox>
                  </template>
                  <template v-slot:cell(boat)="data" >
                    {{data.item.id.split('-')[0]}}
                  </template>
                  <template v-slot:cell(company)="data" >
                    {{data.item.id.split('-')[1]}}
                  </template>
                  <template v-slot:cell(hn_ponto)="data" >
                    {{parseFloat(data.item.hn_ponto).toFixed(2).toString().replace(".", ",")}}
                  </template>

                  <template v-slot:cell(hn_apontado)="data">
                    {{parseFloat(data.item.hn_apontado).toFixed(2).toString().replace(".", ",")}}
                  </template>
                  <template v-slot:cell(difference_hn)="data">
                    {{parseFloat(data.item.difference_hn).toFixed(2).toString().replace(".", ",")}}
                  </template>
                  <template v-slot:cell(he_ponto)="data" >
                    {{parseFloat(data.item.he_ponto).toFixed(2).toString().replace(".", ",")}}
                  </template>
                  <template v-slot:cell(he_apontado)="data">
                    {{parseFloat(data.item.he_apontado).toFixed(2).toString().replace(".", ",")}}
                  </template>
                  <template v-slot:cell(difference_he)="data">
                    {{parseFloat(data.item.difference_he).toFixed(2).toString().replace(".", ",")}}
                  </template>

                  <template v-slot:cell(action)="data">
                    <div :id="`tooltip-action + ${data.item.id}`" class="icon-action">
                      <IconAction v-b-modal.modal-borrow-operator @click="openModalBorrowOperator(data)"/>
                    </div>
                    <b-tooltip
                      :target="`tooltip-action + ${data.item.id}`"
                      triggers="hover blur"
                      positioning="top"
                      placement="top"
                      id="tooltip-emprestar"
                      boundary-padding="0"
                    >
                      <div class="info-tooltip">Emprestar Operador</div>
                    </b-tooltip>
                  </template>
                  <template #head(checkbox)>
                    <b-form-checkbox
                      class="checkbox-header"
                      @change="toggleAll"
                      v-model="allSelected"
                    >
                    </b-form-checkbox>
                  </template>

                   <template #col-right>
                    <div class="row">
                      <div class="col-lg-8 col-md-6">
                        <FormSelect2
                          id="input-workcenter"
                          v-model="workcenter"
                          placeholder='Selecione'
                          :disabled="workcentersByLeader.length == 1"
                          :search="true"
                          :listagem="workcentersByLeader.map((item) => { return { value: item.value, text: item.label, icon: item.icon} })"
                          @input="atualizaListagemApontamentos"
                        />
                      </div>
                      <div class="col-lg-4 col-md-6">
                        <div  id="tooltip-novo-apontamento">
                            <b-button class="button btn-novo-apontamento" :disabled="selected.length == 0" @click="habilitaInfos('novoApontamento')">
                              <span>Novo Apontamento</span>
                            </b-button>
                        </div>

                        <b-tooltip
                            target="tooltip-novo-apontamento"
                            triggers="hover click"
                            positioning="bottom"
                            placement="bottom"
                            class="tooltip-novo-apontamento"
                            v-if="selected.length == 0"
                        >
                            <div class="info-tooltip">
                                Selecione um operador para realizar um apontamento
                            </div>
                        </b-tooltip>
                      </div>
                    </div>
                  </template>
                </table-default>
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="infoNovoApontamento">
        <b-col md="12">
            <b-card class="info-novo-apontamento" :title="(this.flagApontamentos ? 'Novo' : 'Editar') +' Apontamento'">
              <b-row>
                <b-col md=12 >
                  <div class="col-switch">

                    <div class="switch-apontamento">
                      <b-form-checkbox
                        v-model="novoApontamento.custo_industrial"
                        name="check-button"
                        switch
                        inline
                        @change="atualizaCustoIndustrial"
                      >
                      </b-form-checkbox>
                      <span class="legend-checkbox">Custos Industriais</span>
                    </div>

                    <div class="switch-apontamento">
                      <b-form-checkbox
                        v-model="novoApontamento.retrabalho"
                        name="check-button"
                        switch
                        inline
                        @change="atualizaRetrabalho"
                      >
                      </b-form-checkbox>
                      <span class="legend-checkbox">Retrabalho</span>
                    </div>

                    <div class="switch-apontamento">
                      <b-form-checkbox
                        v-model="novoApontamento.hora_extra"
                        name="check-button"
                        switch
                        inline
                        @change="atualizaHoraNovoApontamento"
                        :disabled="acaoAtual == 'edita'"
                      >
                      </b-form-checkbox>
                      <span class="legend-checkbox">Hora Extra</span>
                    </div>

                    <div class="switch-apontamento">
                      <b-form-checkbox
                        v-model="novoApontamento.saldo_apontamento"
                        name="check-button"
                        switch
                        inline
                        @change="novoApontamento.saldo_agrupado = false"
                        :disabled="acaoAtual=='edita'"
                      >
                      </b-form-checkbox>
                      <span class="legend-checkbox">Saldo Apontamento</span>
                      <InfoTooltip id="tooltip-saldo-apontamento" class="tooltip-saldo-apontamento"/>
                    </div>
                    <b-tooltip
                        target="tooltip-saldo-apontamento"
                        triggers="hover click"
                        positioning="bottom"
                        placement="bottom"
                    >
                        <div class="info-tooltip">
                            Alocar saldo de apontamento restante para cada operador
                        </div>
                    </b-tooltip>

                    <div class="switch-apontamento">
                      <b-form-checkbox
                        v-model="novoApontamento.saldo_agrupado"
                        name="check-button"
                        switch
                        inline
                        @change="atualizaSaldo"
                        :disabled="acaoAtual == 'edita'"
                      >
                      </b-form-checkbox>
                      <span class="legend-checkbox">Saldo Agrupado HN e HE</span>
                      <InfoTooltip id="tooltip-saldo-agrupado" class="tooltip-saldo-apontamento"/>
                    </div>
                    <b-tooltip
                        target="tooltip-saldo-agrupado"
                        triggers="hover click"
                        positioning="bottom"
                        placement="bottom"
                    >
                        <div class="info-tooltip">
                            Alocar saldo de apontamento HN e HE restante para cada operador
                        </div>
                    </b-tooltip>

                  </div>
                </b-col>
                <b-col md=12 class="input-filter">
                  <b-form-group label="Centro de Trabalho">
                    <v-select
                      v-model="novoApontamento.workcenter"
                      :options="workcentersByLeader"
                      placeholder='Selecione'
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col md=12 class="input-filter">
                  <b-form-group label="Operador">
                    <v-select
                      placeholder="Selecione"
                      v-model="novoApontamento.operator"
                      :options="(flagApontamentos ? operadoresFiltrados : operatorsList.filter(item => item.workcenter_id == novoApontamento.workcenter[0].value))"
                      multiple
                    />
                  </b-form-group>
                </b-col>
                <b-col md=6 class="input-filter">
                    <b-form-group label="Matrícula">
                      <v-select
                        class="select-filter"
                        v-model="novoApontamento.matricula"
                        :options="listagemMatriculasApontamento"
                        placeholder='Selecione'
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=6 class="input-filter">
                    <b-form-group label="Família">
                      <v-select
                        class="select-filter"
                        v-model="novoApontamento.familia"
                        :options="familiaListFiltro"
                        placeholder='Selecione'
                        :disabled="!novoApontamento.matricula || novoApontamento.matricula.length == 0|| familiaListFiltro.length == 0"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=6 class="input-filter">
                    <b-form-group label="Match">
                      <v-select
                        class="select-filter"
                        v-model="novoApontamento.match"
                        :options="matchListFiltro"
                        placeholder='Selecione'
                        :disabled="!novoApontamento.familia || novoApontamento.familia.length == 0 || matchListFiltro.length == 0"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=6 class="input-filter">
                    <b-form-group label="Local">
                      <v-select
                        class="select-filter"
                        v-model="novoApontamento.local"
                        :options="localListFiltro"
                        placeholder='Selecione'
                        :disabled="!novoApontamento.match || novoApontamento.match.length == 0 || localListFiltro.length == 0"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=12 class="input-filter">
                    <b-form-group label="CDO">
                      <v-select
                        class="select-filter"
                        v-model="novoApontamento.cdo"
                        :options="cdoListFiltro"
                        placeholder='Selecione'
                        :disabled="!novoApontamento.local || novoApontamento.local.length == 0 || cdoListFiltro.length == 0"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=12 class="input-filter">
                    <b-form-group label="Parâmetro">
                      <v-select
                        class="select-filter"
                        v-model="novoApontamento.parametro"
                        :options="parametroListFiltro"
                        placeholder='Selecione'
                        :disabled="!novoApontamento.cdo || novoApontamento.cdo.length == 0 || novoApontamento.retrabalho || parametroListFiltro.length == 0"
                      />
                    </b-form-group>
                  </b-col>
                <b-col md=6 class="col-input-icon input-filter">
                  <FormPicker
                    label="Data"
                    :value="novoApontamento.data"
                    type="data"
                    class="form-date"
                    @input="(value) => updateValue('novoApontamento.data',value)"
                    disabled
                  />
                </b-col>
                <b-col md=6 class="col-input-icon form-input-hora input-filter">
                  <b-form-group label="Hora">
                    <b-form-input
                    v-model="novoApontamento.hora"
                    :disabled='novoApontamento.saldo_apontamento || novoApontamento.saldo_agrupado'
                    type="number"
                    @keydown="numerosValidosHora($event)"
                    @input="formataHora($event)"
                    >
                    </b-form-input>
                    <timeIcon/>
                  </b-form-group>

                </b-col>
                <b-col md=12 class="col-buttons" >
                  <b-button class="button btn-cancelar" @click="cancelarApontamento()">
                    <span>Cancelar</span>
                  </b-button>
                  <b-button class="button btn-salvar" @click="salvarApontamento()" :disabled="!habilitarSalvar()">
                    <span>Salvar</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="infoApropiacaoHoras">
        <b-col md="12">
            <b-card class="info-hora">
              <table-default
              :rows="rowsHora"
              :fields="fieldsHora"
              :stickyHeader="false"
              :striped="true"
              class="tabela-horas"
              :sizeSearchMd="12"
              :sizeSearchLg="12"
              :currentPage="pageHora"
              :totalRows="totalRowsHora"
              :clientPagination="!!textFilterHora"
              serverSide
              @alteraPaginaListagem="alteraPaginaHoras"
              @alteraPerPageListagem="alteraPerPageHoras"
              @buscaTextFilter="buscaTextFilterHoras"
            >
              <template v-slot:cell(extra)="data">
                <div class="hora-extra" :style="`background-color:${data.item.extra == '0' ? '#FFEBEE' : '#E8F5E9'}`">
                  <span :style="`color:${data.item.extra == '0' ? '#F44336' : '#4CAF50'}`">
                    {{ data.item.extra == "0" ? 'Não' : 'Sim'}}
                  </span>
                </div>
              </template>

              <template v-slot:cell(quantity)="data">
                <div>
                  <span>
                    {{parseFloat(data.item.quantity).toFixed(2).toString().replace(".", ",")}}
                  </span>
                </div>
              </template>

              <template v-slot:cell(date)="data">
                <div>
                  <span>
                    {{data.item.date | moment("DD/MM/YYYY")}}
                  </span>
                </div>
              </template>

              <template v-slot:cell(operators)="data">
                <div class="add-ellipsis">
                  <span v-for="(operator,index) in data.item.operators" :key="index">
                    {{data.item.operators.length > 1 ? `${operator},` : operator}}
                  </span>
                </div>
              </template>

              <template v-slot:cell(cdo)="data">
                  <div class="add-ellipsis" :id="`tooltip-cdo + ${data.item.id}`">
                    <span>
                      {{data.item.cdo ? data.item.cdo + ' | ' +  data.item.description_cdo : ''}}
                    </span>
                  </div>

                <b-tooltip
                    :target="`tooltip-cdo + ${data.item.id}`"
                    triggers="hover"
                    positioning="top"
                    placement="top"
                >
                    <div class="info-tooltip">
                       {{data.item.cdo ? data.item.cdo + ' | ' +  data.item.description_cdo : ''}}
                    </div>
                </b-tooltip>
              </template>
              <template v-slot:cell(action)="data">
                <span>
                    <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    class="dropdown-action"
                    >
                    <template v-slot:button-content>
                        <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="dropdown-color align-middle mr-25"
                        />
                    </template>
                    <b-dropdown-item v-b-toggle.sidebar-right-edit @click="editaApontamento(data.item.id)">
                        <EditIcon
                        />
                        <span class="dropdown-itens">Editar</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="deletaApontamento(data.item.id)">
                        <DeleteIcon
                        />
                        <span class="dropdown-itens">Excluir</span>
                    </b-dropdown-item>
                    </b-dropdown>
                </span>
              </template>
            </table-default>
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="infoAvanco">
        <b-col md="12">
            <b-card class="info-avanco">

            <table-default
              :rows="rowsAvanco"
              :fields="fieldsAvanco"
              :stickyHeader="false"
              :striped="true"
              :sizeSearchLg="7"
              class="tabela-avanco"
            >
              <template v-slot:cell(checkbox)="data">
                <b-form-checkbox
                  :id="'checkbox-' + data.index"
                  class="checkbox-row"
                  v-model="novoAvanco.selected"
                  :value="data.item.id"
                >
                </b-form-checkbox>

              </template>

              <template v-slot:cell(progress)="data">
                <div>
                  <span>
                    {{`${data.item.progress}%`}}
                  </span>
                </div>
              </template>

              <template #head(checkbox)>
                <b-form-checkbox
                  class="checkbox-header"
                  @change="toggleAllAvanco"
                  v-model="novoAvanco.allSelected"
                >
                </b-form-checkbox>
              </template>

               <template #col-right>
                <div class="row container-buttons">
                  <div class="col-3 pl-md-0">
                    <div>
                    <button :class="[toggleBtnFIlter ? 'button-filter-close' : 'button-filter-open']" @click='toggleBtnFIlter = !toggleBtnFIlter'>
                      <span><FilterIcon/>Filtrar</span>
                    </button>
                  </div>
                  </div>
                  <div class="col-4 pl-md-0">
                    <div id="tooltip-concluir-avanco">
                      <b-button class="button btn-concluir-avanco" :disabled="novoAvanco.selected.length == 0" @click="salvarNovoAvanco(100)">
                        <span>Concluir</span>
                      </b-button>
                    </div>
                    <b-tooltip
                        target="tooltip-concluir-avanco"
                        triggers="hover click"
                        positioning="bottom"
                        placement="bottom"
                        v-if="novoAvanco.selected.length == 0"
                    >
                        <div class="info-tooltip">
                          Selecione um escopo para concluir
                        </div>
                    </b-tooltip>
                  </div>
                  <div class="col-5 pl-md-0">
                    <div id="tooltip-novo-avanco">
                      <b-button class="button btn-novo-avanco" :disabled="novoAvanco.selected.length == 0" @click="habilitaInfos('novoAvanco')">
                        <span>Novo Avanço</span>
                      </b-button>

                    </div>
                    <b-tooltip
                        target="tooltip-novo-avanco"
                        triggers="hover click"
                        positioning="bottom"
                        placement="bottom"
                        v-if="novoAvanco.selected.length == 0"
                    >
                        <div class="info-tooltip">
                            Selecione um escopo para realizar um avanço
                        </div>
                    </b-tooltip>
                  </div>
                </div>
              </template>

              <template #filter>
                <b-row v-show='toggleBtnFIlter' class="filter-table">
                  <b-col md=6 class="input-filter">
                    <div class="col-switch">
                      <div class="switch-apontamento">
                        <b-form-checkbox
                          v-model="novoAvanco.avanco_concluido"
                          name="check-button"
                          switch
                          inline
                          @change="filtraAvanco"
                        >
                        </b-form-checkbox>
                        <span class="legend-checkbox">Avanço concluído</span>
                      </div>
                    </div>
                  </b-col>
                  <b-col md=6 class="clear-filter input-filter">
                    <div>
                      <b-button class="btn-clear" @click="clearFilterAvanco"
                      :disabled="!novoAvanco.local && !novoAvanco.familia &&
                      !novoAvanco.matricula && !novoAvanco.match && !novoAvanco.cdo && !novoAvanco.avanco_concluido
                      ">
                        <span>Limpar Filtro</span>
                      </b-button>
                    </div>
                  </b-col>
                  <b-col md=6 class="input-filter">
                    <b-form-group label="Matrícula">
                      <v-select
                        class="select-filter"
                        v-model="novoAvanco.matricula"
                        :options="matriculaListFiltro"
                        placeholder='Selecione'
                        multiple
                        @input="filtraAvanco"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=6 class="input-filter">
                    <b-form-group label="Família">
                      <v-select
                        class="select-filter"
                        v-model="novoAvanco.familia"
                        :options="familiaListFiltro"
                        placeholder='Selecione'
                        multiple
                        @input="filtraAvanco"
                        :disabled="!novoAvanco.matricula || novoAvanco.matricula.length == 0"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=6 class="input-filter">
                    <b-form-group label="Match">
                      <v-select
                        class="select-filter"
                        v-model="novoAvanco.match"
                        :options="matchListFiltro"
                        placeholder='Selecione'
                        multiple
                        @input="filtraAvanco"
                        :disabled="!novoAvanco.familia || novoAvanco.familia.length == 0"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=6 class="input-filter">
                    <b-form-group label="Local">
                      <v-select
                        class="select-filter"
                        v-model="novoAvanco.local"
                        :options="localListFiltro"
                        placeholder='Selecione'
                        multiple
                        @input="filtraAvanco"
                        :disabled="!novoAvanco.match || novoAvanco.match.length == 0"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md=12 class="input-filter">
                    <b-form-group label="CDO">
                      <v-select
                        class="select-filter"
                        v-model="novoAvanco.cdo"
                        :options="cdoListFiltro"
                        placeholder='Selecione'
                        :disabled="!novoAvanco.local || novoAvanco.local.length == 0"
                        multiple
                        @input="filtraAvanco"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </template>
            </table-default>

            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="infoNovoAvanco">
      <b-col md="12">
          <b-card class="info-novo-avanco" title="Avançar Escopo">
            <b-row>
              <b-col md=12 class="col-12 avancar-escopo">
                <b-form-group label="Escopo">
                    <div class="escopo">
                      <div v-for="(item, index) in escopoList" :key="index" class="item-escopo"> {{item}}</div>
                    </div>
                </b-form-group>
                <InputProgress
                  @atualizaProgress="(value) => atualizaProgress(value)"
                  :valueInputProgress="progress"
                />
              </b-col>
              <b-col md=12 class="button buttons-novo-avanco" >
                <b-button class="button btn-cancelar" @click="habilitaInfos('avanco')">
                  <span>Cancelar</span>
                </b-button>
                <b-button class="button btn-salvar" @click="salvarNovoAvanco(progressAvanco)">
                  <span>Salvar</span>
                </b-button>
              </b-col>
            </b-row>

          </b-card>
      </b-col>
  </b-row>

  <!--  -->
  <b-row v-if="infoDivergencias">
    <b-col md="12">
      <b-card class="info-hora">
        <table-default
          :rows="rowsDivergenciasFiltered"
          :fields="fieldsDivergencias"
          :stickyHeader="false"
          :striped="true"
          class="tabela-divergencia"
          :sizeSearchLg="10"
          :sizeSearchMd="9"
        >
          <template #col-right>
            <div class="switch-apontamento d-flex align-items-center switch-divergencias">
              <b-form-checkbox
                v-model="checkDivergencia"
                name="check-button-divergencia"
                switch
                inline
                @change="filterDivergencias"
              >
              </b-form-checkbox>
                <span class="legend-checkbox">Divergências</span>
            </div>
          </template>
          <template v-slot:cell(action)="data">
            <span class="d-flex align-items-center justify-content-center">
              <InfoDetailIcon v-b-modal.modal-table @click="getDataCDODetails(data.item.routing_id, data.item.cdo)"/>
            </span>
          </template>

          <template v-slot:cell(cdo)="data">
            <div class="add-ellipsis --ellipsis-divergencia">
              <span :id="`tooltip-divergencias-cdo-${data.index}`">
                {{data.item.cdo ? data.item.cdo + ' | ' +  data.item.cdo_description : ''}}
              </span>
            </div>
            <b-tooltip
              :target="`tooltip-divergencias-cdo-${data.index}`"
              triggers="hover blur"
              positioning="top"
              placement="top"
            >
              <div class="info-tooltip">
                {{data.item.cdo ? data.item.cdo + ' | ' +  data.item.cdo_description : ''}}
              </div>
            </b-tooltip>
          </template>

          <template v-slot:cell(operation_progress)="data">
            <span class="d-flex align-items-center">
              <CheckCircleIcon v-if="data.item.operation_progress == '1'"/>
              <CloseCircleIcon v-else/>
            </span>
          </template>
          <template v-slot:cell(step)="data">
            <span class="d-flex align-items-center">
              <CheckCircleIcon v-if="data.item.step == '1'"/>
              <CloseCircleIcon v-else/>
            </span>
          </template>
        </table-default>
      </b-card>
    </b-col>
  </b-row>
  </b-overlay>
</template>

<script>
import Breadcrumb from '../../../layouts/components/Breadcrumb.vue'
import EditIcon from '@/assets/images/pages/Edit.svg'
import DeleteIcon from '@/assets/images/pages/Delete.svg'
import FilterIcon from '@/assets/images/pages/Filter.svg'
import InfoDetailIcon from '@/assets/images/pages/info-detail.svg';
import CloseCircleIcon from '@/assets/images/pages/close-circle.svg';
import CheckCircleIcon from '@/assets/images/pages/check-circle.svg';
import Ripple from 'vue-ripple-directive'
import moment from "moment";
import {
BRow,BCol,BButton, BModal, BAvatar, BBadge, BPagination, BFormGroup, BFormCheckbox ,BFormInput, BFormSelect, BAlert, BDropdown, BDropdownItem, BCard, BOverlay,BTooltip
} from 'bootstrap-vue'
import TableDefault from "@core/components/table-default/TableDefault.vue";
import CloseIcon from '@/assets/images/pages/close-icon.svg'
import FormPicker from "../../../@core/components/form-picker/FormPicker.vue";
import timeIcon from '@/assets/images/pages/time-icon.svg'
import vSelect from 'vue-select'
import CarouselCalendar from "../../../@core/components/carousel-calendar/CarouselCalendar.vue";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import InfoTooltip from '@/assets/images/pages/info-tooltip.svg'
import IconAction from '@/assets/images/pages/return-icon.svg'
import ModalBorrowOperation from '@core/components/b-modal/ModalBorrowOperation.vue';
import ModalTable from '@/@core/components/b-modal/ModalTable.vue';
import InputProgress from '@core/components/input-progress/InputProgress.vue';
import FormSelect2 from '@core/components/form-select-2/FormSelect2.vue';
export default {
components: {
    BRow,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BCard,
    BOverlay,
    BCol,
    BButton,
    BModal,
    BFormCheckbox,
    Breadcrumb,
    TableDefault,
    CloseIcon,
    FormPicker,
    timeIcon,
    vSelect,
    EditIcon,
    DeleteIcon,
    FilterIcon,
    InfoDetailIcon,
    CheckCircleIcon,
    CloseCircleIcon,
    CarouselCalendar,
    ToastificationContent,
    BTooltip,
    InfoTooltip,
    IconAction,
    ModalBorrowOperation,
    ModalTable,
    InputProgress,
    FormSelect2
},
directives: {
        Ripple,
    },
data() {
  return {
    checkDivergencia: false,
    alerts:[],
    operator:{
      id: null,
      name: null,
    },
    toggleBtnFIlter: false,
    novoApontamento: {
      retrabalho:false,
      saldo_apontamento:false,
      hora_extra:false,
      saldo_agrupado:false,
      custo_industrial:false,
      workcenter:'',
      operator:'',
      matricula:'',
      familia:'',
      match:'',
      local:'',
      cdo:'',
      hora:'',
      data:'',
      parametro:''
    },
    novoAvanco: {
      allSelected: false,
      selected: [],
      avanco_concluido:'',
      matricula:'',
      familia:'',
      cdo:'',
      local:'',
      match:'',
      escopo:'',
      value:''
    },
    escopoList:[],
    cdoList:[],
    cdoListFiltrado:[],
    cdoListFiltro:[],
    parametroListFiltro:[],
    operatorsList:[],
    familiaListFiltro:[],
    matriculaListFiltro:[],
    localListFiltro:[],
    matchListFiltro:[],
    erroApontamento:false,
    infoApontamentos: true,
    infoApropiacaoHoras: false,
    infoNovoApontamento: false,
    infoAvanco: false,
    infoNovoAvanco: false,
    infoDivergencias: false,
    flagApontamentos:true,
    flagApropiacaoHoras:false,
    flagAvanco:false,
    flagDivergencias: false,
    fieldsApontamento: [
      {
        label: '',
        key: 'checkbox',
        sortable: false,
        class:"col-sm-header"
      },
      {
        label: 'AÇÃO',
        key: 'action',
        sortable: false,
        class:"col-sm-header"
      },
      {
        label: 'MATRÍCULA',
        key: 'boat',
        sortable: true
      },
      {
        label: 'EMPRESA',
        key: 'company',
        sortable: true
      },
      {
        label: 'OPERADOR',
        key: 'name',
        sortable: true,
        class:"operators"
      },
      {
        label: 'HN PONTO',
        key: 'hn_ponto',
        sortable: true
      },
      {
        label: 'HN APONTADO',
        key: 'hn_apontado',
        sortable: true
      },
      {
        label: 'HN SALDO',
        key: 'difference_hn',
        sortable: true,
      },
      {
        label: 'HE PONTO',
        key: 'he_ponto',
        sortable: true,
      },
      {
        label: 'HE APONTADO',
        key: 'he_apontado',
        sortable: true
      },
      {
        label: 'HE SALDO',
        key: 'difference_he',
        sortable: true,

      },
    ],
    fieldsHora: [
      {
        label: 'AÇÕES',
        key: 'action',
        sortable: false,
        class:"col-sm-header"
      },
      {
        label: 'ID APP',
        key: 'id',
        sortable: true
      },
      {
        label: 'MATRÍCULA',
        key: 'boat',
        sortable: true,
        class: "text-nowrap"
      },
      {
        label: 'FAMÍLIA',
        key: 'family',
        sortable: true
      },
      {
        label: 'CENTRO DE TRABALHO',
        key: 'workcenter',
        class: "text-nowrap",
        sortable: true,
      },
      {
        label: 'LOCAL',
        key: 'local',
        sortable: true,
        class: "text-nowrap"
      },
      {
        label: 'CDO',
        key: 'cdo',
        sortable: true,
        class: "text-nowrap"
      },
      {
        label: 'DATA',
        key: 'date',
        sortable: true
      },
      {
        label: 'HH APONTADO',
        key: 'quantity',
        sortable: true
      },
      {
        label: 'HORA EXTRA',
        key: 'extra',
        sortable: true,
      },
      {
        label: 'OPERADOR',
        key: 'operators',
        sortable: true,
        class: "text-nowrap"
      },
      {
        label: 'USUÁRIO',
        key: 'leader',
        sortable: true,

      },

    ],
    fieldsAvanco: [
      {
        label: '',
        key: 'checkbox',
        sortable: false,
        class:"col-sm-header"
      },
      {
        label: 'FAMÍLIA',
        key: 'family',
        sortable: true
      },
      {
        label: 'MATRÍCULA',
        key: 'boat',
        sortable: true,
        class: 'text-nowrap'
      },
      {
        label: 'LOCAL',
        key: 'local',
        sortable: true
      },
      {
        label: 'MATCH',
        key: 'match',
        sortable: true,

      },
      {
        label: 'CDO',
        key: 'cdo',
        sortable: true,
        class: 'text-nowrap'

      },
      {
        label: 'DESCRIÇÃO CDO',
        key: 'cdo_description',
        sortable: true,
        class: 'text-nowrap'
      },
      {
        label: 'ESCOPO',
        key: 'scope',
        sortable: true,

      },
      {
        label: 'AVANÇO',
        key: 'progress',
        sortable: true,
      },
    ],
    fieldsDivergencias: [
      {
        label: 'AÇÃO',
        key: 'action',
        sortable: true,
        class: 'text-center'
      },
      {
        label: 'FAMÍLIA',
        key: 'family',
        sortable: true
      },
      {
        label: 'MATRÍCULA',
        key: 'boat',
        sortable: true,
        class: 'text-nowrap'
      },
      {
        label: 'CDO',
        key: 'cdo',
        sortable: true,
        class: 'text-nowrap'
      },
      {
        label: 'LOCAL',
        key: 'local',
        sortable: true,
        class: 'text-nowrap'
      },
      {
        label: 'MATCH',
        key: 'match',
        sortable: true,
        class: 'text-nowrap'
      },
      {
        label: 'PARÂMETRO',
        key: 'param',
        sortable: true,
        class: 'text-nowrap'
      },
      {
        label: 'APONTAMENTO',
        key: 'operation_progress',
        sortable: true,
      },
      {
        label: 'AVANÇO',
        key: 'step',
        sortable: true,
      },
    ],
    fieldsCDO: [
      {
        label: 'DATA',
        key: 'date',
        sortable: true,
      },
      {
        label: 'CENTRO DE TRABALHO',
        key: 'workcenter',
        class: "text-nowrap",
        sortable: true,
      },
      {
        label: 'OPERADOR',
        key: 'operator',
        class: "text-nowrap",
        sortable: true,
      }
    ],
    rowsApontamento: [],
    rowsHora: [],
    pageHora: 1,
    perPageHora: 10,
    totalRowsHora: 0,
    textFilterHora: '',
    rowsAvanco: [],
    rowsDivergencias: [],
    rowsDivergenciasFiltered: [],
    rowsCDO: [],
    cdoID: '',
    showOverlay: false,
    workcentersList:[],
    workcentersListFiltered:[],
    workcentersByLeader:[],
    workcenter: null,
    selected: [],
    allSelected: false,
    mesAtualApontamento:'',
    datasInconsistentes:[],
    datasApontamentos:[],
    mesesApontamentos:[],
    idAtual:'',
    acaoAtual:'novo',
    progressAvanco:'',
    rowsApontamentofiltrado:[],
    operadoresFiltrados:[],
    dataAtualApontamento:'',
    datasDivergencias:[],
    progress:'',
    rowsAvancofiltrado:[],
    urlAvanco:'',
    margemApontamento: -0.33,
    listagemMatriculasApontamento:[],
    listagemCDOApontamento:[],
  }
},
watch:{
    'novoAvanco.matricula'(){
      this.contextoFamilias(this.novoAvanco.matricula)
      this.novoAvanco.familia = ''
      this.novoAvanco.match = ''
      this.novoAvanco.local = ''
      this.novoAvanco.cdo = ''
    },
    'novoAvanco.familia'(){
      this.contextoMatches(this.novoAvanco.matricula, this.novoAvanco.familia)
      this.novoAvanco.match = ''
      this.novoAvanco.local = ''
      this.novoAvanco.cdo = ''
    },
    'novoAvanco.match'(){
      this.contextoLocais(this.novoAvanco.matricula, this.novoAvanco.familia, this.novoAvanco.match)
      this.novoAvanco.local = ''
      this.novoAvanco.cdo = ''
    },
    'novoAvanco.local'(){
      this.contextoCDOs(this.novoAvanco.matricula, this.novoAvanco.familia, this.novoAvanco.match, this.novoAvanco.local)
      this.novoAvanco.cdo = ''
    },
    'novoApontamento.matricula'(_, oldValue){
      this.familiaListFiltro = []
      this.contextoFamiliasApontamento(this.novoApontamento.matricula)
      if(oldValue !== ""){
        this.novoApontamento.familia = ''
        this.novoApontamento.match = ''
        this.novoApontamento.local = ''
        this.novoApontamento.cdo = ''
        this.novoApontamento.parametro = ''
      }
    },
    'novoApontamento.familia'(_, oldValue){
      this.matchListFiltro = []
      this.contextoMatchesApontamento(this.novoApontamento.matricula, this.novoApontamento.familia)
      if(oldValue !== ""){
        this.novoApontamento.match = ''
        this.novoApontamento.local = ''
        this.novoApontamento.cdo = ''
        this.novoApontamento.parametro = ''
      }
    },
    'novoApontamento.match'(_, oldValue){
      this.localListFiltro = []
      this.contextoLocaisApontamento(this.novoApontamento.matricula, this.novoApontamento.familia, this.novoApontamento.match)
      if(oldValue !== ""){
        this.novoApontamento.local = ''
        this.novoApontamento.cdo = ''
        this.novoApontamento.parametro = ''
      }
    },
    'novoApontamento.local'(_, oldValue){
      this.cdoListFiltro = []
      this.contextoCDOsApontamento(this.novoApontamento.matricula, this.novoApontamento.familia, this.novoApontamento.match, this.novoApontamento.local)
      if(oldValue !== ""){
        this.novoApontamento.cdo = ''
        this.novoApontamento.parametro = ''
      }
    },
    'novoApontamento.cdo'(){
      this.parametroListFiltro = []
      this.novoApontamento.parametro = ''
      this.contextoParametrosApontamento(this.novoApontamento.matricula, this.novoApontamento.familia, this.novoApontamento.match, this.novoApontamento.local, this.novoApontamento.cdo.value)

    },
},
mounted() {
  this.showOverlay = true;
  this.getProductionHoursOperators('');
  this.getWorkcenters();
  this.getWorkcentersByLeader();
  this.getAlerts();
  this.closeTooltip();
  this.contextoMatriculasApontamento()
  this.contextoApontamento()

},
computed: {
  queryStringIndustrialCost(){
    return this.novoApontamento.custo_industrial ? '&industrial_cost=true' : '';
  }
},
methods: {
  atualizaPaginaApontamento(){
    this.habilitaInfos('apontamentos')
    this.getProductionHoursOperators(`?dateFilter=${this.datasInconsistentes[0]}`)

  },
  async contextoApontamento(){
    this.showOverlay = true
    await this.$http.get(`/api/production_hours/context`)
      .then(async res => {
        this.operatorsList = []
        res.data.operators.map((item) => {return this.operatorsList.push({value: item.id,label:item.name, workcenter_id: item.workcenter_id})})
    })
  },
  atualizaCustoIndustrial(){
    this.novoApontamento.retrabalho = false
    this.novoApontamento.matricula = ''
    this.contextoMatriculasApontamento()
  },
  closeTooltip(){
      document.body.addEventListener('scroll', ()=>{
      let tooltip = document.querySelector('.tooltip');
      if(tooltip){
        tooltip.style.display = 'none';
      }
    })
  },
  contextoMatriculas(){
    this.matriculaListFiltro = []
    this.$http.get(`api/steps/context_boats`)
    .then(res => {
      this.matriculaListFiltro = res.data.boats
    })
  },
  joinDataFilterContextsAPI(data){
    return Array.isArray(data) ? data.join() : data;
  },
  async contextoFamilias(matricula){
    await this.$http.get(`api/steps/context_families?boats=${this.joinDataFilterContextsAPI(matricula)}`)
    .then(res => {
      this.familiaListFiltro = res.data.families
    })
  },
  async contextoMatches(matricula, familia){
    await this.$http.get(`api/steps/context_matches?boats=${this.joinDataFilterContextsAPI(matricula)}&families=${this.joinDataFilterContextsAPI(familia)}`)
    .then(res => {
      this.matchListFiltro = res.data.matches
    })
  },
  async contextoLocais(matricula, familia, match){
    await this.$http.get(`api/steps/context_locales?boats=${this.joinDataFilterContextsAPI(matricula)}&families=${this.joinDataFilterContextsAPI(familia)}&matches=${this.joinDataFilterContextsAPI(match)}`)
    .then(res => {
      this.localListFiltro = res.data.locales
    })
  },
  async contextoCDOs(matricula, familia, match, local){
    await this.$http.get(`api/steps/context_cdos?boats=${this.joinDataFilterContextsAPI(matricula)}&families=${this.joinDataFilterContextsAPI(familia)}&matches=${this.joinDataFilterContextsAPI(match)}&locales=${this.joinDataFilterContextsAPI(local)}`)
    .then(res => {
      this.listagemCDOApontamento = res.data.cdo
      this.cdoListFiltro = this.listagemCDOApontamento.map(item => {return {value:item.cdo ,label:`${item.cdo} | ${item.description_cdo}`}})
    })
  },
  async contextoMatriculasApontamento(){
    this.listagemMatriculasApontamento = []
    await this.$http.get(`api/production_hours/context_boats${this.novoApontamento.custo_industrial ? '?industrial_cost=true' : ''}`)
    .then(res => {
      this.listagemMatriculasApontamento = res.data.boats
    })
  },
  async contextoFamiliasApontamento(matricula){
    await this.$http.get(`api/production_hours/context_families?boats=${this.joinDataFilterContextsAPI(matricula)}${this.novoApontamento.retrabalho ? '&ret=true' : ''}${this.queryStringIndustrialCost}`)
    .then(res => {
      this.familiaListFiltro = res.data.families
    })
  },
  async contextoMatchesApontamento(matricula, familia){
    await this.$http.get(`api/production_hours/context_matches?boats=${this.joinDataFilterContextsAPI(matricula)}&families=${this.joinDataFilterContextsAPI(familia)}${this.novoApontamento.retrabalho ? '&ret=true' : ''}${this.queryStringIndustrialCost}`)
    .then(res => {
      this.matchListFiltro = res.data.matches
    })
  },
  async contextoLocaisApontamento(matricula, familia, match){
    await this.$http.get(`api/production_hours/context_locales?boats=${this.joinDataFilterContextsAPI(matricula)}&families=${this.joinDataFilterContextsAPI(familia)}&matches=${this.joinDataFilterContextsAPI(match)}${this.queryStringIndustrialCost}`)
    .then(res => {
      this.localListFiltro = res.data.locales
    })
  },
  async contextoCDOsApontamento(matricula, familia, match, local){
    await this.$http.get(`api/production_hours/context_cdos?boats=${this.joinDataFilterContextsAPI(matricula)}&families=${this.joinDataFilterContextsAPI(familia)}&matches=${this.joinDataFilterContextsAPI(match)}&locales=${this.joinDataFilterContextsAPI(local)}${this.queryStringIndustrialCost}`)
    .then(res => {
      this.listagemCDOApontamento = res.data.cdo
      this.cdoListFiltro = this.listagemCDOApontamento.map(item => {return {value:item.cdo ,label:`${item.cdo} | ${item.description_cdo}`}})
    })
  },
  async contextoParametrosApontamento(matricula, familia, match, local, cdo){
    await this.$http.get(`api/production_hours/context_params?boats=${this.joinDataFilterContextsAPI(matricula)}&families=${this.joinDataFilterContextsAPI(familia)}&matches=${this.joinDataFilterContextsAPI(match)}&locales=${this.joinDataFilterContextsAPI(local)}&cdo=${this.joinDataFilterContextsAPI(cdo)}`)
    .then(res => {
      this.parametroListFiltro = res.data.params
    })
  },
  atualizaSaldo(){
    if (this.novoApontamento.saldo_agrupado){
      this.novoApontamento.saldo_apontamento = false
      this.novoApontamento.hora_extra = false
      this.atualizaHoraNovoApontamento()
    }
  },
  openModalBorrowOperator(data){
    this.getOperator(data.item.id, data.item.name);
    this.workcentersListFiltered = this.workcentersList.filter(workcenter => workcenter.value != data.item.workcenter_id);
  },
  getOperator(id, name){
    this.operator.id = id;
    this.operator.name = name;
  },
  getAlerts(newAlert = false){
    this.$http.get('/api/operators/notifications')
      .then(res => {
        this.alerts = res.data;
      }).catch(e => console.error(e));
    if(newAlert) {
      this.getProductionHoursOperators('');
      this.atualizaListagemApontamentos();
    };
  },
  closeAlert(ids, index){
    document.querySelector(`#alert-${index}`).style.display = 'none';
    this.$http.put('/api/operators/notifications',
      {
        "ids": ids,
      }).then(() => {
        this.getAlerts();
      }).catch(e => console.error(e));
  },
   filtraAvanco(){
      this.urlAvanco = '?'

      if (this.novoAvanco.local.length > 0){
          this.urlAvanco += `locales=${this.novoAvanco.local.map(item => item)}&`
      }
      if (this.novoAvanco.familia.length > 0){
          this.urlAvanco += `families=${this.novoAvanco.familia.map(item => item)}&`
      }
      if (this.novoAvanco.matricula.length > 0){
          this.urlAvanco += `boats=${this.novoAvanco.matricula.map(item => item)}&`
      }
      if (this.novoAvanco.match.length > 0){
          this.urlAvanco += `matches=${this.novoAvanco.match.map(item => item)}&`
      }
      if (this.novoAvanco.cdo.length > 0){
          this.urlAvanco += `cdos=${this.novoAvanco.cdo.map(item => item.value)}&`
      }
      if(this.novoAvanco.avanco_concluido){
          this.urlAvanco += `completed=1`
      }
      this.getAvancos(this.urlAvanco)
    },
  formataHora($event){
    let novaHora = $event;
    novaHora = $event.replace('.', '');
    if(novaHora.length >=4 && novaHora[0] == '0') {
      novaHora = novaHora.substring(1);
    }
    novaHora = novaHora.replace(/(\d+)(\d{2})/, '$1.$2');
    this.novoApontamento.hora = novaHora;
  },
  atualizaRetrabalho(){
    this.novoApontamento.matricula = '';
    if(this.novoApontamento.retrabalho && this.novoApontamento.custo_industrial){
      this.novoApontamento.custo_industrial = false
    }
    this.contextoMatriculasApontamento()
  },
  cancelarApontamento(){
    this.habilitaInfos((this.flagApontamentos ? 'apontamentos' : 'horas'))
    this.selected = []
    this.allSelected = false
  },
  atualizaListagemApontamentos(){
    this.rowsApontamentofiltrado = []
    if(this.workcenter != null){
      this.rowsApontamento.filter(item =>{ return this.workcenter == item.workcenter_id ? this.rowsApontamentofiltrado.push(item): ''})
    } else {
      this.rowsApontamentofiltrado = this.rowsApontamento;
    }

  },
  atualizaProgress(value){
    this.progressAvanco = value;
  },
  salvarNovoAvanco(progress){
    this.showOverlay = true;
    this.$http.put(`/api/steps`,
          {
            ids:this.novoAvanco.selected,
            progress: progress
          }).then(res => {
                  this.habilitaInfos('avanco')
                  this.showToast('Sucesso', 'SmileIcon', 'Avanço registrado com sucesso', 'success')

              })
              .catch((error) => {
                  this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
              })
  },
  updateValue(campo, value) {
      const [parent, elem] = campo.split(".");
      this[parent][elem] = value;
  },
  deletaApontamento(id){
    this.$swal({
        title: 'Atenção',
        text: "Ao excluir um apontamento ele não poderá ser desfeito. Tem certeza que deseja excluir mesmo assim?",
        showCancelButton: true,
        showCloseButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Excluir',
        customClass: {
          container: 'swal-apontamento',
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$http.put(`/api/production_hours/${id}/delete`)
            .then(() => {
              this.showToast('Sucesso', 'SmileIcon', 'Apontamento excluído com sucesso', 'success');
              this.getApropriacaoHoras();
            })
            .catch((error) => {
              this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
            })
        }
      })
  },
  validaApontamento(id){
    const abilityList = JSON.parse(localStorage.getItem('userData')).ability;
    if (abilityList.find(element => element.action === 'manage')) {
        return true;
    }

    let maxDays = 7;
    const filteredSubjects = abilityList.filter(item => item.subject !== "basic");

    if (filteredSubjects.length === 1 && filteredSubjects[0].subject === 'operator'){
        maxDays = 30;
    }
    
    const dataApontamento = id ? this.rowsHora.filter(item => item.id == id)[0].date : this.novoApontamento.data
    const currentDataNote = new Date(dataApontamento);
    const today = new Date();
    const timeDiff = Math.abs(today.getTime() - currentDataNote.getTime());
    const diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

    if(diffDays > maxDays){
      return false
    }
    else{
      return true
    }
  },
  async editaApontamento(id){
    if (this.validaApontamento(id)){
      this.showOverlay = true
      this.habilitaInfos('editarApontamento')
      await this.$http.get(`/api/production_hours/${id}`)
      .then(async response => {
        this.novoApontamento.workcenter = this.workcentersByLeader.filter(item => item.value == response.data[0].workcenter_id);
        this.selected = response.data[0].operators;
        this.novoApontamento.operator = this.operatorsList.filter(operador => this.selected.includes(operador.value));
        this.novoApontamento.data = moment(response.data[0].date).format("YYYY-MM-DD");
        this.novoApontamento.matricula = response.data[0].boat;
        await this.contextoFamiliasApontamento(this.novoApontamento.matricula)
        this.novoApontamento.familia = response.data[0].family;
        await this.contextoLocaisApontamento(this.novoApontamento.matricula, this.novoApontamento.familia)
        this.novoApontamento.local = response.data[0].local;
        await this.contextoMatchesApontamento(this.novoApontamento.matricula, this.novoApontamento.familia, this.novoApontamento.local)
        this.novoApontamento.match = response.data[0].match;
        await this.contextoCDOsApontamento(this.novoApontamento.matricula, this.novoApontamento.familia, this.novoApontamento.match, this.novoApontamento.local)
        this.novoApontamento.cdo = {value:  response.data[0].cdo, label: `${response.data[0].cdo} | ${response.data[0].description_cdo}`};
        await this.contextoParametrosApontamento(this.novoApontamento.matricula, this.novoApontamento.familia, this.novoApontamento.match, this.novoApontamento.local, this.novoApontamento.cdo.value)
        this.novoApontamento.parametro = response.data[0].param
        this.novoApontamento.hora = response.data[0].quantity;
        this.novoApontamento.retrabalho = response.data[0].rework == '1' ? true : false;
        this.novoApontamento.hora_extra = response.data[0].extra == '1' ? true : false;
        this.idAtual = response.data[0].id;
        this.acaoAtual = 'edita'
        this.showOverlay=false
      })
    }
    else{
      let maxDays = 7;
      const filteredSubjects = JSON.parse(localStorage.getItem('userData')).ability.filter(item => item.subject !== "basic");
      if (filteredSubjects.length === 1 && filteredSubjects[0].subject === 'operator'){
        maxDays = 30;
      }
      this.showToast('Erro', 'FrownIcon',`Já se passaram ${maxDays} dias desde a data da última carga do ponto`, 'danger')
    }

  },
  habilitarSalvar() {
    return (
      this.novoApontamento.data &&
      this.novoApontamento.match &&
      this.novoApontamento.local &&
      this.novoApontamento.matricula &&
      this.novoApontamento.familia &&
      this.novoApontamento.cdo &&
      (this.novoApontamento.hora || this.novoApontamento.saldo_apontamento || this.novoApontamento.saldo_agrupado) &&
      (this.novoApontamento.parametro || this.novoApontamento.retrabalho) &&
      this.novoApontamento.operator?.length > 0
    )
  },
  salvarApontamento(){
    if (this.validaApontamento('')){
      if(this.acaoAtual == 'novo'){
        this.showOverlay = true;
        this.$http.post(`/api/production_hours`,
          {
            date: this.novoApontamento.data,
            boat: this.novoApontamento.matricula,
            family: this.novoApontamento.familia,
            local: this.novoApontamento.local,
            match: this.novoApontamento.match,
            cdo: this.novoApontamento.cdo.value,
            quantity: this.novoApontamento.hora.replace(",", "."),
            rework: this.novoApontamento.retrabalho,
            operators: this.novoApontamento.operator.reduce((filtered,item) => {filtered.push(item.value); return filtered}, []),
            balance: this.novoApontamento.saldo_apontamento,
            extra:this.novoApontamento.hora_extra,
            grouped: this.novoApontamento.saldo_agrupado,
            param:this.novoApontamento.parametro,
            industrial_costs: this.novoApontamento.custo_industrial

          }).then(res => {
                this.habilitaInfos('apontamentos')
                this.showToast('Sucesso', 'SmileIcon', 'Apontamento registrado com sucesso', 'success')
                this.getProductionHoursOperators(`?dateFilter=${this.novoApontamento.data}`)
                this.novoApontamento.matricula = ''
                this.novoApontamento.familia =''
                this.novoApontamento.cdo = ''
                this.novoApontamento.hora = ''
                this.novoApontamento.data = ''
                this.novoApontamento.retrabalho = false
                this.selected = []
                this.novoApontamento.saldo_apontamento = false
                this.novoApontamento.hora_extra = false
                this.novoApontamento.saldo_agrupado = false
                this.novoApontamento.custo_industrial = false
            })
            .catch((error) => {
                this.showToast('Erro', 'FrownIcon',error.response.data.message, 'danger')
                this.showOverlay = false;
            })
      }
      else{
        this.showOverlay = true;
        this.$http.put(`/api/production_hours/${this.idAtual}`,
            {
              date: this.novoApontamento.data,
              boat: this.novoApontamento.matricula,
              family: this.novoApontamento.familia,
              local: this.novoApontamento.local,
              match: this.novoApontamento.match,
              cdo: this.novoApontamento.cdo.value,
              quantity: this.novoApontamento.hora.replace(",", "."),
              rework: this.novoApontamento.retrabalho,
              operators: this.novoApontamento.operator.reduce((filtered,item) => {filtered.push(item.value); return filtered}, []),
              balance: this.novoApontamento.saldo_apontamento,
              extra:this.novoApontamento.hora_extra,
              grouped: this.novoApontamento.saldo_agrupado,
              param:this.novoApontamento.parametro,
              industrial_costs: this.novoApontamento.custo_industrial
            }).then(res => {
                    this.habilitaInfos('horas')
                    this.showToast('Sucesso', 'SmileIcon', 'Apontamento editado com sucesso', 'success')
                    this.acaoAtual = 'novo'


                })
                .catch((error) => {
                    this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
                    this.showOverlay = false;

                })
      }
    }
    else{
      let maxDays = 7;
      const filteredSubjects = JSON.parse(localStorage.getItem('userData')).ability.filter(item => item.subject !== "basic");
      if (filteredSubjects.length === 1 && filteredSubjects[0].subject === 'operator'){
        maxDays = 30;
      }
      this.showToast('Erro', 'FrownIcon',`Já se passaram ${maxDays} dias desde a data da última carga do ponto`, 'danger')
    }
  },
  showToast(title, icon, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          text: text,
          variant,
        },
      })
    },


atualizaHoraNovoApontamento(){
  if(this.novoApontamento.hora_extra){
    this.novoApontamento.saldo_agrupado = false
  }
  if(this.selected.length == 1){
    let apontamentoSelecionado = this.rowsApontamentofiltrado.filter(item => this.selected.includes(item.id))[0]
    this.novoApontamento.hora = parseFloat( this.novoApontamento.hora_extra ? apontamentoSelecionado.difference_he : apontamentoSelecionado.difference_hn).toFixed(2)
  }else{
    this.novoApontamento.hora = ''
  }
},
contextoNovoApontamento(tipo = ''){
  this.acaoAtual = 'novo'
  this.novoApontamento.custo_industrial = false
  this.novoApontamento.saldo_agrupado = false
  this.novoApontamento.retrabalho = false
  this.novoApontamento.saldo_apontamento = false
  this.novoApontamento.hora_extra = false
  this.novoApontamento.matricula = ''
  this.novoApontamento.familia = ''
  this.novoApontamento.cdo = ''
  this.operadoresFiltrados = this.operatorsList.filter(operador => this.selected.includes(operador.value))
  this.novoApontamento.operator = this.operadoresFiltrados

  this.novoApontamento.workcenter = this.workcentersByLeader.filter(item => item.value == this.workcenter);
  this.novoApontamento.data = this.dataAtualApontamento
  if (tipo != "editarApontamento") {
    this.atualizaHoraNovoApontamento();
  }
  this.atualizaCustoIndustrial()
},
contextoAvanco(){
  this.showOverlay = true;
  this.novoAvanco.selected = []
  this.contextoMatriculas()
  this.filtraAvanco()
},
limpaFiltrosAvanco(){
  this.novoAvanco.matricula = ''
  this.novoAvanco.familia = ''
  this.novoAvanco.cdo = ''
  this.novoAvanco.match = ''
  this.novoAvanco.local = ''
},
contextoNovoAvanco(){
  this.escopoList = []
  this.progress = 0
  this.rowsAvanco.filter(item => this.novoAvanco.selected.map(selecionado => {return item.id == selecionado ? this.escopoList.push(item.scope) : ''}))
  if (this.novoAvanco.selected.length == 1){
    this.progress = parseFloat(this.rowsAvanco.filter(item => this.novoAvanco.selected[0] == item.id)[0].progress)
  }
},
getWorkcenters(){
  this.$http.get(`/api/workcenters/loan`)
    .then(res => {
      res.data.map((item) => {return this.workcentersList.push({value: item.id,label: item.name})})
      let workcentersListSorted = this.workcentersList.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      this.workcentersList = workcentersListSorted;
    })
},
getWorkcentersByLeader(){
  this.$http.get(`/api/workcenters_by_leader`)
    .then(res => {
      res.data.map((item) => {return this.workcentersByLeader.push({value: item.id,label: item.name, icon: item.inconsistency})})
      this.workcentersByLeader = this.workcentersByLeader.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      this.workcenter = this.workcentersByLeader[0].value
      this.atualizaListagemApontamentos()
    })
},
calculaDatasDivergencias(dia){ // Adiciona na listagem de divergências as datas entre o dia recebido pela função e a data atual
    if(dia){
      let listagemDivergencias = []
      let diaDivergencia = dia
      let dataAtual = new Date(Date.now()).toISOString().substring(0,10)
      const diffInMs   = new Date(dataAtual) - new Date(diaDivergencia)
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

      for (var i = 0; i < diffInDays; i++) {
        let próximaData = new Date (new Date(diaDivergencia).setDate(new Date(diaDivergencia).getDate() + i)).toISOString().substring(0,10)
        listagemDivergencias.push(próximaData)
      }
      return listagemDivergencias
    }
},
async getProductionHoursOperators(urlFiltro){
  this.showOverlay = true;
  this.selected = [];
  this.allSelected = false;
  this.infoApontamentos = false;

  let url = '/api/production_hours/operators' + urlFiltro
  await this.$http.get(url)
    .then(async res => {

      this.datasDivergencias = this.calculaDatasDivergencias(res.data.divergence)
      this.dataAtualApontamento = res.data.dateFilter;
      this.mesAtualApontamento = res.data.monthFilter;
      this.datasInconsistentes = res.data.control_point_dates_inconsistency;
      this.datasApontamentos = res.data.control_point_dates;
      this.mesesApontamentos = res.data.control_point_month;
      this.rowsApontamento = res.data.operators.map(item => {
            return {
                ...item,
                _rowVariant: `${parseFloat(item.difference_hn) != 0 || parseFloat(item.difference_he) != 0 ? 'danger' : '' }`
            };
        });
      this.atualizaListagemApontamentos()
      if(this.datasInconsistentes.length > 0){
        this.erroApontamento = true
      }
      this.showOverlay = false;
      this.infoApontamentos = true;
    })
},
getApropriacaoHoras(){
  this.showOverlay = true;
  let url = this.textFilterHora
    ? `/api/production_hours?textFilter=${encodeURIComponent(this.textFilterHora)}`
    : `/api/production_hours?page=${this.pageHora}&perPage=${this.perPageHora}`;
  this.$http.get(url)
    .then(res => {
      const payload = res.data;
      if (Array.isArray(payload)) {
        this.rowsHora = payload;
        this.totalRowsHora = payload.length;
      } else {
        this.rowsHora = payload.data || payload.items || [];
        this.totalRowsHora = payload.total ?? payload.meta?.total ?? this.rowsHora.length;
      }
      this.showOverlay = false;
    })
},
alteraPaginaHoras(page) {
  if (this.textFilterHora) return;
  this.pageHora = page;
  this.getApropriacaoHoras();
},
alteraPerPageHoras(perPage) {
  if (this.textFilterHora) return;
  this.perPageHora = perPage;
  this.pageHora = 1;
  this.getApropriacaoHoras();
},
buscaTextFilterHoras(text) {
  this.textFilterHora = text.trim();
  this.pageHora = 1;
  this.getApropriacaoHoras();
},
getAvancos(url){
  this.showOverlay = true;
  this.$http.get(`/api/steps`+ url)
    .then(res => {
      this.rowsAvanco = res.data
      this.showOverlay = false;
      })
},
toggleAll() {
  this.selected = [];
  if (this.allSelected) {
    this.rowsApontamentofiltrado.map(item => {
      if((parseFloat(item.difference_hn)!= 0 || parseFloat(item.difference_he)!= 0) && (parseFloat(item.difference_hn) >= this.margemApontamento) && (parseFloat(item.difference_he) >= this.margemApontamento) ){
        this.selected.push(item.id)
      }
    })
  }
},
toggleAllAvanco() {
  this.novoAvanco.selected = [];
  if (this.novoAvanco.allSelected) {
    this.rowsAvanco.map(item => {return this.novoAvanco.selected.push(item.id)})
  }
},
clearFilterAvanco() {
  this.novoAvanco.local = ''
  this.novoAvanco.familia = ''
  this.novoAvanco.matricula =''
  this.novoAvanco.local = ''
  this.novoAvanco.match = ''
  this.novoAvanco.cdo = ''
  this.novoAvanco.avanco_concluido = ''
  this.filtraAvanco()
},
habilitaInfos(tipo) {
    this.infoApontamentos = false;
    this.infoNovoApontamento = false;
    this.infoApropiacaoHoras = false;
    this.infoAvanco = false;
    this.infoNovoAvanco = false;
    this.infoDivergencias = false;
    this.flagApropiacaoHoras = false;
    this.flagAvanco = false;
    this.flagApontamentos = false;
    this.flagDivergencias = false;
    if (tipo == "apontamentos") {
        this.infoApontamentos = true;
        this.flagApontamentos = true;
        this.limpaFiltrosAvanco();
    } else if (tipo == "horas") {
        this.infoApropiacaoHoras = true;
        this.flagApropiacaoHoras = true;
        this.getApropriacaoHoras();
    } else if (tipo == "novoApontamento") {
        this.flagApontamentos = true;
        this.infoNovoApontamento = true;
        this.contextoNovoApontamento()
    } else if (tipo == "editarApontamento") {
      this.flagApropiacaoHoras = true;
      this.infoNovoApontamento = true;
      this.contextoNovoApontamento(tipo)
    } else if (tipo == "novoAvanco") {
        this.flagAvanco = true;
        this.infoNovoAvanco = true;
        this.contextoNovoAvanco();

    } else if (tipo == "divergencias") {
        this.flagDivergencias = true;
        this.infoDivergencias = true;
        this.getDataDivergencias();
    } else {
        this.infoAvanco = true;
        this.flagAvanco = true;
        this.contextoAvanco()
    }
},
numerosValidosHora(event) {
  if (isNaN(event.key) && event.key !== ',' && event.keyCode >= 32) {
    event.preventDefault();
  }
},
getDataDivergencias(){
  this.showOverlay = true
  this.$http.get(`/api/operations_progress_steps`)
    .then(res => {
      this.rowsDivergencias = res.data;
      this.rowsDivergenciasFiltered = res.data;
      this.showOverlay = false
      this.filterDivergencias()
    }).catch(e => console.error(e));
},
getDataCDODetails(id, cdo){
  this.$http.get(`api/production_hours/details?routing_id=${id}`)
    .then(res => {
      this.rowsCDO = res.data;
      this.cdoID = cdo;
    }).catch(e => console.error(e));
},
filterDivergencias(){
  if(this.checkDivergencia) {
    this.rowsDivergenciasFiltered = this.rowsDivergencias.filter(item => {
      if((item.operation_progress == '1' && item.step == '0') || (item.operation_progress == '0' && item.step == '1')){
        return item;
      }
    })
  } else {
    this.rowsDivergenciasFiltered = this.rowsDivergencias;
  }
}
},
}

</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import '~@core/scss/vue/libs/vue-select.scss';


@media (max-width: 480px) {
  .width-cdo-date-column{
    width: 95px;
  }
  .width-cdo-operator-column{
    width: 104px;
  }
  .width-cdo-workcenter-column{
    width: 170px;
  }
  .alerta-apontamentos{
    .alerta-apontamentos-item{
      span{
        font-size: 12px;
      }
      svg{
        scale: 0.8;
      }
    }
  }
  .container-buttons{
    flex-direction: column;
  }
  .container-buttons > div {
    max-width: 100%;
    padding-top: 0px;
  }
  .info-novo-apontamento{
    .col-switch{
      flex-direction: column;
      .switch-apontamento{
        margin-bottom: 16px;
      }
    }
  }
  .form-input-hora{
    margin-top: 16px;
  }
  .not-found{
    span{
      h3{
        font-size: 15px !important;
        line-height: 16px !important;
      }
    }
  }
  .content-header-left{
    margin-bottom: 0 !important;
    .breadcrumb-wrapper{
      margin: 0;
    }
    .breadcrumb-second-item{
      padding: 0;
    }
  }
  #tooltip-emprestar{
    display: none !important;
  }
}

.--ellipsis-divergencia{
  max-width: 90% !important;
}

.switch-divergencias{
  height: 100% !important;
}

.tabela-divergencia thead tr th:nth-child(4){
  width: 59%;
}
.tabela-divergencia tbody tr td:nth-child(4){
  width: 59%;
  max-width: 280px;
}

.tooltip{
  .tooltip-inner{
    max-width: 363px !important;
    .info-tooltip{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }
}


@media (min-width:768px) {
  #modal-borrow-operator{
    padding: 0 !important;
    .modal-content,
    .modal-dialog{
      width: 746px !important;
    }
  }
}

#modal-borrow-operator{
  padding: 20px 0 0 8px;
  .modal-dialog{
    width: 95%;
    max-width: none;
  }
  .modal-content{
    width: 100%;
    right: 0 !important;
  }
  .modal-header{
    height: 66px;
    background: #ECEFF1;
  }
  .modal-body{
    padding: 6px 2px 0.8rem !important;
    .title-modal{
      h5{
        height: 20px;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        color: #4C4541;
        margin-bottom: 0;
      }
      .container-title-text-modal{
        margin-top: -72px;
        height: 66px;
        width: 100%;
      }
    }
    #workcenter-select{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }

    #operator-select{
      border: 1px solid #7E7570;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #7E7570;
    }

    .col-form-label{
      color: #4C4541;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
    }
    .container-btn-borrow{
      margin: 20px 0;
      .btn-borrow {
        height: 46px;
        background-color: #974900 !important;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 17px;
        line-height: 20px;
      }
    }
  }
}

.swal-apontamento{
  .swal2-modal{
    padding: 0 !important;
    border-radius: 6px;
    width: 710px;
    .swal2-header{
      background-color: #D32F2F;
      padding: 20px 16px;
      border-radius: 6px 6px 0px 0px;
      flex-direction: row;
      justify-content: left;
      .swal2-title{
        color: #ffff;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        margin: 0;
      }
      .swal2-close{
        border-radius: 6px;
        width: 34px;
        background-color: #ffff;
        height: 34px;
        top: -5px;
        position: absolute;
        right: -5px;
      }
    }
    .swal2-content{
      padding: 20px 16px;
      .swal2-html-container{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #4C4541;
        display: flex !important;

      }
    }
    .swal2-actions{
      padding:  0 16px 20px 16px;
      display: flex;
      justify-content: right;
      .swal2-confirm{
        margin-left: 10px !important;
        order: 2;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 20px;
        color: #ffff;
        border-color:#974900 !important;
        background-color: #974900 !important;
        border-radius: 5px;
        &:hover{
          box-shadow: none !important;
        }
      }
      .swal2-cancel{
        order: 1;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 20px;
        color: #974900 !important;
        border-radius: 5px;
        border-color: transparent !important;
        &:hover{
          background-color:  #ffede1 !important;
        }
      }
    }
  }
}

.vue-slider-rail{
  background: #F7F3EF !important;
  border-radius: 3px;
}

.info-novo-avanco{
  .card-title{
    font-weight: 600 !important;
  }
  .avancar-escopo{
    margin-bottom: 0;
    padding: 0 16px;
    .form-group{
      margin-bottom: 0;
      .col-form-label{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #4C4541;
      }
    }
  }

  .buttons-novo-avanco{
    padding-top: 0px;
    margin-top: 20px;
    display: flex;
    justify-content: end;
    .btn-cancelar{
        padding: 13px 28px;
        background-color: transparent !important;
        border-radius: 5px;
        margin-right: 16px;
        span{
        color: #974900;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 20px;
    }
    &:hover{
      background-color:  #ffede1 !important;
    }
    }
    .btn-salvar{
        padding: 13px 28px;
        background-color: #974900 !important;
        border-radius: 5px;
        span{
        color: #fff;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 20px;
      }
      &:hover{
        background-color: #9d5815 !important;
      }

    }
  }

  .escopo{
    display: flex;
    flex-wrap: wrap;

    .item-escopo{
      background-color: #974900 !important;
      margin: 3px 6px 0px 0px;
      border-radius: 5px;
      padding: 2px 5px;
      color: #FFFFFF;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }
}

.vue-slider-process{
  background-color: #974900 !important;
}

.vue-slider-dot-handle{
  border: 2px solid #974900;
}
.vue-slider-dot-tooltip-top{
  display: none;
}

.value-box{
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: 30px;
  margin-bottom: 0px;
}

.filter-options{
  padding: 0;
}

.not-found{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  border: 1px solid #CFC4BE;
  margin: 16px;
  border-radius: 5px;
  span{
    display: flex;
    align-items: baseline;
    h3{
      text-align: center;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 26px;
      color: #998F8A;
    }
    svg{
      margin-right: 16.13px;
    }
  }
}

.input-filter{
  padding: 0px 16px;
  .select-filter{
    background-color: #FFFFFF !important;
  }
}

.filter-table{
  border-top: 1px solid #9E9E9E;
  border-bottom: 1px solid #9E9E9E;
  margin: 0 0 16px 0;
  padding: 16px 0 0 0;
  background-color: #FAFAFA !important;
}
.button-filter-close{
  font-family: 'Roboto';
  padding: 9px 21px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  background-color: #FFDBC4 !important;
  color: #974900 !important;
  border: 1px solid #974900;
  border-radius: 5px;
  width: 100%;

  span{
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
      margin-right: 8.58px;
    }
  }
}

.button-filter-open,
.btn-concluir-avanco{
  background-color: #fff !important;
  font-family: 'Roboto';
  padding: 9px 21px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #974900 !important;
  border: 1px solid #974900 !important;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  width: 100%;

  span{
    display: flex;
    align-items: center;
    svg{
      margin-right: 8.58px;
    }
  }
  &.disabled{
      background-color: #ECE0DB !important;
      span{
        color: #7E7570;
      }
      border: 1px solid transparent !important;
    }
}

.btn-concluir-avanco:focus{
  background-color: #fff !important;
}

.clear-filter{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  .btn-clear{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #974900 !important;
    padding: 2px 14px;
    background: #FAFAFA !important;
    border: 1px solid #974900 !important;
    border-radius: 5px;
  }
}

.add-ellipsis{
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.hora-extra{
  padding: 1px 9px;
  background: #E8F5E9;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  margin: 10px;
}

.dropdown-color{
  color: #974900
  }



.button{
  border: none;
  &:hover{
    box-shadow: none !important;
  }
}

.dropdown-action{
  .dropdown-item{
    display: flex;
    align-items: center;
    svg{
      margin-right: 9px;
    }
    &:hover{
      span{
        color: #974900 !important;
      }
      svg{
        path{
          fill: #974900 !important;
        }
      }
    }
  }
}

.custom-select{
  background: url("data:image/svg+xml;charset=utf8,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.47162 3.05602L5.00158 7.5909L0.528469 3.05593L1.17644 2.40774L4.73416 6.02906L5.00178 6.30146L5.26928 6.02894L8.82368 2.40785L9.47162 3.05602Z' fill='%23CFC4BE' stroke='%23CFC4BE' stroke-width='0.75'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 14px bottom 50%!important;

  &:disabled {
    background-color: #eeeeee !important;
    border: 1px solid #7e7570;
    color: #7e7570;
  }
}

.alertas-apontamentos{
  margin-bottom: 8px;
}

.alerta-apontamentos-row{
  padding: 4px 1rem !important;
}

.alerta-apontamentos{
  background-color: #FFEBEE;
  border: 1px solid #EF5350;
  border-radius: 6px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .icon-close{
    cursor: pointer;
    scale: 0.9;
  }
  span{
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  }
}

.--apontamento-red{
  background-color: #FFEBEE;
  border: 1px solid #EF5350;
  span{
    color: #B71C1C;
  }
}

.--apontamento-gray{
  background-color: #ECEFF1;
  border: 1px solid #78909C;
  span{
    color: #263238;
  }
}

.row-buttons-pages{
  width: 100%;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none !important;
  }
  .col-btn-pages{
      min-width: 715px;
      display: flex;
      padding-bottom: 4px !important;
    .button-page{
      padding: 8px;
      background-color: transparent !important;
      display: flex;
      flex-direction: column;
      border: none;
      border-radius: 6px;
      margin-right: 20px;
      width: 207px;
      span{
        color: #998F8A !important;
      }
      .title-button{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 26px;
        margin-bottom: 4px;
      }
      .sub-title-button{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
      }
      &:hover{
        cursor: pointer;
      }
      &.active{
        background-color: #974900 !important;
        span{
          color: #ffff !important;
        }
      }
    }
  }
}
.info-apontamento, .info-horas, .info-avanco{
  .tabela-apontamentos, .tabela-horas, .tabela-avanco, .tabela-divergencias{
    .icon-action{
      cursor: pointer;
      border-radius: 5px;
      &:hover{
        background-color: #FFEDE2;
      }
    }
    .v-select{
      .vs__selected{
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis !important;
       width: calc(85%);
      }
      &.vs--single.vs--searching {
        .vs__selected{
          display: none !important;
        }
      }
      &.select-filter{
        .vs__selected{
          width: auto;
        }
      }

    }
    .custom-control-label{
      cursor: pointer;
    }
     .custom-control-input[disabled] ~ .custom-control-label{
      cursor: not-allowed !important;
     }
    .custom-control-input[disabled] ~ .custom-control-label::before, [dir] .custom-control-input:disabled ~ .custom-control-label::before {
      background-color: #ECE0DB !important;
      border: #d8d6de solid 1px !important;
    }
    .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
      background-color: #fff;
      border-color: #d8d6de;
    }

    .checkbox-row .custom-control-input:checked ~ .custom-control-label::before {
      border-color: #974900;
      background-color: #974900;
      box-shadow: none !important;
    }
    .checkbox-header .custom-control-input:checked ~ .custom-control-label::after {
      background-image: none;
    }
    .checkbox-header .custom-control-input:checked ~ .custom-control-label::before {
      border-color: #d8d6de ;
      box-shadow: none !important;
      background-image: -webkit-linear-gradient(-45deg, #fff 50%, #974900 50%);
    }
  }
  .btn-novo-apontamento,.btn-novo-avanco{
    background-color: #974900 !important;
    padding: 9px 21px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #ECE0DB !important;
    span{
      color: #ffff;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
    }
    &.disabled{
      background-color: #ECE0DB !important;
      span{
        color: #7E7570;
      }
    }
  }
}
.info-novo-apontamento{
  .card-title{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    color: #4C4541;
  }
  .form-group{
    margin-bottom: 16px;
    .col-form-label{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #4C4541;
    }
  }
  .col-buttons{
    margin-top: 20px;
    display: flex;
    justify-content: end;
    .btn-cancelar{
        padding: 13px 28px;
        background-color: transparent !important;
        border-radius: 5px;
        margin-right: 16px;
        span{
        color: #974900;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 20px;
    }
    &:hover{
      background-color:  #ffede1 !important;
    }
    }
    .btn-salvar{
        padding: 13px 28px;
        background-color: #974900 !important;
        border-radius: 5px;
        span{
        color: #fff;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 20px;
      }
      &:hover{
        background-color: #9d5815 !important;
      }

    }
  }

  .col-switch{
    margin-bottom: 16px;
    display: flex;
    .switch-apontamento{
      margin-right: 16px;
      display: flex;
      align-items: center;
      .custom-control-input[disabled] ~ .custom-control-label{
        &::before, &::after{
          cursor: not-allowed !important;
        }
      }
      .tooltip-saldo-apontamento{
        margin-left: 8px;
        margin-top: 4px;
      }
      .legend-checkbox{
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #4C4541 !important;

      }
      .custom-switch{
        margin: 0;
      }
      span{
        margin-top: 5px;
      }
      .custom-control-input:checked ~ .custom-control-label::before{
        border-color: #974900 !important;
          background-color: #974900 !important;
      }
    }
  }

  .form-date {
    .form-group {
      position: relative;
      margin-bottom: 0;
      .flatpickr-wrapper {
        width: 100% !important;
      }
      .custom-select {
        background: url("data:image/svg+xml;charset=utf8,%3Csvg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.47162 2.05602L5.00158 6.5909L0.528469 2.05593L1.17644 1.40774L4.73416 5.02906L5.00178 5.30146L5.26928 5.02894L8.82368 1.40785L9.47162 2.05602Z' fill='%237E7570' stroke='%237E7570' stroke-width='0.75'/%3E%3C/svg%3E")
          right 1rem center/10px 10px no-repeat;

        &:disabled {
          background-color: #eeeeee !important;
          border: 1px solid #7e7570;
          color: #7e7570;
        }
      }
    }
  }
}
.col-input-icon {
.form-control {
padding: 9px 14px 9px 42px;
&:disabled {
  background-color: #f8f8f8 !important;
  border: 1px solid #d8d6de;
  color: #7e7570;
}
}
.form-control[readonly] {
background-color: #ffff;
}
svg {
position: absolute;
top: 50%;
left: 14px;
transform: translateY(-50%);
}
&.form-input-hora{
svg{
  left: 28px;
  top: 55%;
}
}
}

.vs__selected{
background-color: #974900;
font-family: 'Roboto';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
color: #ffff;
svg{
path{
  fill: #ffff !important;
}
}
}

</style>
